module.exports = __webpack_public_path__ + "static/media/recruiter@4x.872c5626.png";